import { Suspense, lazy } from 'react';
import './App.css';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';
import Spinner from './components/Spinner/index.js';

const Layout = lazy(() => import('./Layout'));
const Auth = lazy(() => import('./Auth'));
const Login = lazy(() => import('./views/pages/login/Login'));
const ForgotPassword = lazy(() => import('./views/pages/forgot_password/ForgotPassword'));
const Page404 = lazy(() => import('./views/pages/page404/Page404'));
const Page500 = lazy(() => import('./views/pages/page500/Page500'));
const AboutUsPage = lazy(() => import('./views/pages/cms_pages/About_Us_Page'));
const ContactUsPage = lazy(() => import('./views/pages/cms_pages/Contact_Us_Page'));
const PrivacyPolicyPage = lazy(() => import('./views/pages/cms_pages/Privacy_Policy_Page'));
const TermsConditionPage = lazy(() => import('./views/pages/cms_pages/Terms_Condition_Page'));
const FAQPage = lazy(() => import('./views/pages/cms_pages/FAQ_Page.js'));


function App() {

  let {isLoading} = useSelector(state => state.session);

  return (
    <div className='theme-orange'>
      <BrowserRouter>
        <Suspense>
          <Routes>
            
            <Route exact path='/login' element={
              <Auth requiresAuth={false} redirectTo="/dashboard">
                <Login />
              </Auth>
            } />
            <Route exact path='/forgot_password' element={
              <Auth requiresAuth={false} redirectTo="/dashboard">
                <ForgotPassword />
              </Auth>
            } />
            {/* <Route exact path='/forgot_password' element={<ForgotPassword />} /> */}
            <Route exact path='/404' element={<Page404 />} />
            <Route exact path='/500' element={<Page500 />} />

            <Route path="*" element={
              <Auth requiresAuth={true} redirectTo="/login">
                <Layout />
              </Auth>
            } />

            <Route path="*" element={<Navigate to="/dashboard" replace />} />

            {/* To load CMS Pages */}
            <Route exact path='/home/aboutus' element={<AboutUsPage />} />
            <Route exact path='/home/contactus' element={<ContactUsPage />} />
            <Route exact path='/home/privacypolicy' element={<PrivacyPolicyPage />} />
            <Route exact path='/home/termscondition' element={<TermsConditionPage />} />
            <Route exact path='/home/faqs' element={<FAQPage />} />

          </Routes>
        </Suspense>
      </BrowserRouter>
      <ToastContainer />
      {isLoading && <Spinner />}
    </div>
  );
}

export default App;
